<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('eartag.Select_free_eartag_for_retagging') }}</h5>
    <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <div class="col-8">
            <div class="input-group input-group-static null">
              <select id="tagId" v-model="localFormData.tagId" class="form-control form-control-default">
                  <option value="">{{ $t('eartag.Select_EarTag') }}</option>
                  <option v-for="item in tags" :key="item.id" :value="item.id">
                      {{ item.tagNumber }}
                  </option>
              </select>
              <span v-if="v$.tagId.$error" class="text-sm text-danger">
                  {{ v$.tagId.$errors[0].$message }}
              </span>                
            </div>
        </div>
      </div>      
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="validateAndPrevStep">{{ $t('common.Prev') }}</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, reactive, watch } from 'vue'
  import { required, helpers } from '@vuelidate/validators'
  import useVuelidate from '@vuelidate/core'
  import { useI18n } from 'vue-i18n'
  
  export default {
    name: "DepartureUbn",
    props: {
      tags: Array,      
      formData: Object,
      prevStep: Function,
      nextStep: Function
    },
    setup(props, { emit }) {
      const { t } = useI18n()
      const localFormData = reactive(props.formData)

      const displayText = (f) => {
        let parts = [];

        if (f.tagNumber) parts.push(f.tagNumber);
        if (f.workNumber) parts.push(f.workNumber);
        //if (f.tagManufacturerCode) parts.push(`(${f.tagManufacturerCode})`);
        if (f.tagManufacturerName) parts.push(f.tagManufacturerName);
        if (f.supplieDate) {
            const dateObj = new Date(f.supplieDate);
            const day = String(dateObj.getDate()).padStart(2, '0');
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const year = dateObj.getFullYear();
            const formattedDate = `${day}-${month}-${year}`;

            parts.push(`<span style="color: green">${formattedDate}</span>`);
        }
        if (f.breedCode) parts.push(`(${f.breedCode})`);
        
        return parts.join(' | ');
      }

      const rules = computed(() => ({
        tagId: {
          required: helpers.withMessage(t('common.Required'), required)
        }
      }))
            
      const v$ = useVuelidate(rules, localFormData, { $autoDirty: true })

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndPrevStep = async () => {
        v$.value.$touch()
        if (v$.value.$pending) {
          await v$.value.$validate()
        }
        if (!v$.value.$invalid) {    
          const selectedTag = props.tags.find(t => t.id === localFormData.tagId)
          localFormData.tagDetails = selectedTag ? displayText(selectedTag) : ''      
          props.prevStep()
        }
      }

      const validateAndNextStep = async () => {
        v$.value.$touch()
        if (v$.value.$pending) {
          await v$.value.$validate()
        }
        if (!v$.value.$invalid) {
          const selectedTag = props.tags.find(t => t.id === localFormData.tagId)
          localFormData.tagDetails = selectedTag ? displayText(selectedTag) : ''
          props.nextStep()
        }        
      }

      return {
        localFormData, 
        displayText,              
        validateAndPrevStep,
        validateAndNextStep,
        v$
      }
    }    
};
</script>
<style scoped>
.card {
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  position: relative;
  padding: 10px !important;
}
.cursor-pointer {
  cursor: pointer;
}
.bg-light {
  background-color: #f9f9f9 !important;
}
.border-success {
  border-color: #28a745 !important;
}
</style>